import { render, staticRenderFns } from "./HenanMobileElm01.vue?vue&type=template&id=fb631cc2&scoped=true"
import script from "./HenanMobileElm01.vue?vue&type=script&lang=js"
export * from "./HenanMobileElm01.vue?vue&type=script&lang=js"
import style0 from "./HenanMobileElm01.vue?vue&type=style&index=0&id=fb631cc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb631cc2",
  null
  
)

export default component.exports